var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clients-teaser grid grid__base" }, [
    _c("div", { staticClass: "grid--container" }, [
      _vm.title
        ? _c("div", { staticClass: "grid--row" }, [
            _c("div", { staticClass: "grid--col" }, [
              _c("h2", { staticClass: "clients-teaser--title" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clients-teaser--container grid--container" }, [
      _c("div", { staticClass: "grid--row" }, [
        _c(
          "div",
          { staticClass: "clients-teaser--col grid--col" },
          [
            _c(
              "auto-slider",
              { attrs: { "item-count": _vm.itemCount } },
              [_vm._t("default")],
              2
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2986765b", { render: render, staticRenderFns: staticRenderFns })
  }
}